module.exports = __webpack_public_path__ + "media/images/errors/404-78ac048348ccd090bca7a20792ed45c6.jpg";